var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPreviewPlayIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 18.3334C5.39795 18.3334 1.66699 14.6024 1.66699 10C1.66699 5.39765 5.39795 1.66669 10.0003 1.66669C14.6027 1.66669 18.3337 5.39765 18.3337 10C18.3337 14.6024 14.6027 18.3334 10.0003 18.3334ZM10.0003 16.6667C13.6822 16.6667 16.667 13.6819 16.667 10C16.667 6.31812 13.6822 3.33335 10.0003 3.33335C6.31843 3.33335 3.33366 6.31812 3.33366 10C3.33366 13.6819 6.31843 16.6667 10.0003 16.6667ZM8.85191 7.01218L12.9177 9.72269C13.0708 9.82477 13.1122 10.0318 13.0101 10.1849C12.9857 10.2215 12.9542 10.2529 12.9177 10.2774L8.85191 12.9879C8.69874 13.09 8.49174 13.0486 8.38966 12.8954C8.35316 12.8407 8.33366 12.7764 8.33366 12.7105V7.28953C8.33366 7.10543 8.48291 6.9562 8.66699 6.9562C8.73283 6.9562 8.79716 6.97567 8.85191 7.01218Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPreviewPlayIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PreviewPlayIcon.0e3776fb.svg";
export { ForwardRef as ReactComponent };